export function changeDOB(idUser, dob) {  return { type: 'USER/DOB/CHANGE', idUser, dob }}